import { useQuery } from "@tanstack/react-query";
import { assetService } from "../../api/assetService";
import Badge from "../../components/ui/Badge";
import { getErrorMessage } from "../../utils/apiError";
import { formatDate } from "../../utils/date";
import { formatManilaDate } from "../../utils/manilaTime";
import { cx } from "../../utils/classNames";
import { ASSIGNMENT_STATUS, MY_ASSETS_KEY } from "./assetUtils";
import ui from "../../components/ui/ui.module.css";

const COLUMN_COUNT = 6;

const AssetHistoryTable = () => {
  const query = useQuery({
    queryKey: [MY_ASSETS_KEY, "history"],
    queryFn: () => assetService.getMyAssignments({ view: "history" }),
  });

  const rows = query.data?.data ?? [];

  const message = query.isLoading
    ? "Loading history…"
    : query.isError
      ? getErrorMessage(query.error, "Unable to load your asset history.")
      : rows.length === 0
        ? "No returned assets yet."
        : "";

  return (
    <div className={ui.tableWrapper}>
      <table className={ui.table}>
        <thead>
          <tr>
            <th>Asset</th>
            <th>Assigned</th>
            <th>Date received</th>
            <th>Returned</th>
            <th>Condition in</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {message && (
            <tr>
              <td
                colSpan={COLUMN_COUNT}
                className={
                  query.isError ? "text-danger" : cx(ui.muted, "text-center")
                }
              >
                {message}
              </td>
            </tr>
          )}

          {rows.map((assignment) => {
            const status = ASSIGNMENT_STATUS[assignment.status] ?? {
              label: assignment.status,
              tone: "gray",
            };
            return (
              <tr key={assignment.id}>
                <td>
                  <div className={ui.strong}>{assignment.asset?.name}</div>
                  <div className={ui.muted}>{assignment.asset?.assetTag}</div>
                </td>
                <td className={ui.noWrap}>
                  {formatManilaDate(assignment.assignedAt)}
                </td>
                <td className={ui.noWrap}>
                  {assignment.dateReceived
                    ? formatDate(assignment.dateReceived)
                    : "—"}
                </td>
                <td className={ui.noWrap}>
                  {formatManilaDate(assignment.returnedAt)}
                </td>
                <td>{assignment.conditionIn ?? "—"}</td>
                <td>
                  <Badge tone={status.tone}>{status.label}</Badge>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AssetHistoryTable;
